export const getChannelLambdaEndpoint =
  'https://hwml60od9i.execute-api.us-east-1.amazonaws.com/default/youtubeGetChannel'

export const getContentsLambdaEndpoint =
  'https://m0v7dr1zz2.execute-api.us-east-1.amazonaws.com/default/youtubeGetPlaylistContents'

export const getHandleLambdaEndpoint =
  'https://gbt7w5u4c1.execute-api.us-east-1.amazonaws.com/default/youtubeGetPlaylistFromHandle'
